import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import type { SxProps } from '@material-ui/system';
import logo from '../res/img/banner_sponsor_last.png';

interface LogoProps {
  sx?: SxProps<Theme>;
}
const Logo: FC<LogoProps> = (props) => (
  <div>
    <img src={logo} width={"100%"} height="50"/>
  </div>
);

export default Logo;
